/**
 * Temporary constant for reaction search prototype.
 *
 * TODO(BNCH-145194): remove this constant and use actual Reaction model type constant.
 */

export const REACTION_PSEUDO_TYPE = 'reaction';
